export default "__VITE_ASSET__CnRViFDd__"